import accurateInterval from 'accurate-interval'

const TIMER_STEP = 1000

class Timer {
    timer
    timerStep
    timeElapsed

    constructor (timerStep = TIMER_STEP) {
      this.timerStep = timerStep
      this.timeElapsed = 0
    }

    startTimer () {
      if (this.timer && this.timer.clear) {
        return
      }

      const timer = accurateInterval(
        () => this.incrementTimer(),
        this.timerStep,
        { aligned: true })

      this.setTimer(timer)
    }

    stopTimer () {
      if (this.timer && this.timer.clear) {
        this.timer.clear()
      }

      this.setTimer(null)
    }

    incrementTimer () {
      this.timeElapsed += this.timerStep
    }

    setTimer (timer) {
      this.timer = timer
    }
}

export default Timer
